// extracted by mini-css-extract-plugin
export default {"container":"Select_container__qj6ls","main":"Select_main__R4DGa","rotate":"Select_rotate__M4j-b","options":"Select_options__bPeZl","option":"Select_option__5wf31"};